<template>
  <ul class="tabs">
    <li
      class="tab"
      v-for="(item, index) in list"
      :key="index"
      :class="{ 'tab--active': activeTab === index }"
      @click="changeTab(item.path)"
    >
      {{ item.name }}
    </li>
  </ul>
</template>

<script>
export default {
  name: 'MineTabs',
  props: {
    data: Array
  },
  data() {
    return {
      list: [
        { name: '我购买的服务', path: '/mine' },
        { name: '我的订单', path: '/mine/orders' },
        { name: '我的关注', path: '/mine/follow' },
        { name: '我的浏览记录', path: '/mine/browse' },
        { name: '我的财币', path: '/mine/vcurrency' },
        { name: '个人信息', path: '/mine/info' },
        { name: '意见反馈', path: '/mine/feedback' }
      ]
    }
  },
  computed: {
    activeTab() {
      const path = this.$route.path

      return this.list.findIndex(item =>
        item.path === '/mine' ? item.path === path : ~path.indexOf(item.path)
      )
    }
  },
  methods: {
    changeTab(path) {
      this.$router.push(path)
    }
  }
}
</script>

<style lang="scss" scoped>
.tabs {
  width: 332px;
  margin-top: 30px;
  line-height: 40px;
  font-size: 16px;
  color: #262626;
  text-align: left;
  border-bottom: 4px solid #046bcc;
  display: flex;
  flex-direction: column;

  .tab {
    padding-left: 20px;
    cursor: pointer;
    border-left: 4px solid transparent;
  }

  .tab--active {
    position: relative;
    border-color: #046bcc;
    color: #046bcc;

    background-color: rgba($color: #046bcc, $alpha: 0.1);
  }
}
</style>
